import { ApolloError } from '@apollo/client';
import { createContext, useContext } from 'react';
import { ITrimSelectedLevel } from '../model/ITrimSelectedLevel';

interface ITrimLevelContext {
  modelName?: string;
  trimName: string;
  selectedTrimLevels?: ITrimSelectedLevel[];
  loading?: boolean;
  error?: ApolloError;
}

export const TrimLevelContext = createContext<ITrimLevelContext>(null);

export function useTrimLevel(): ITrimLevelContext {
  const context = useContext(TrimLevelContext);

  if (!context) {
    return {} as ITrimLevelContext;
  }

  return context;
}

export const TrimLevelProvider = TrimLevelContext.Provider;
